import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import MeRepository from '../../../helpers/api/MeRepository';

export default class DivisionComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
    };
    this.onChange = this.onChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
    if (this.props.selectedItem?.id == null && items?.length == 1) this.props.onChange(items[0]);
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];

    try {
      items = await MeRepository.getDivisions();
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxDivision"
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        disabled={this.state.items < 1 || this.props.disabled}
        //RITM0945977
        // placeholder="Choose a Division"
        placeholder="Choose a Business Line"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.code.toLowerCase().includes(inputValue.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.name : '')}
        selectedItem={this.props.selectedItem}
      />
    );
  }
}

DivisionComboBox.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  disabled: PropTypes.bool,
};
DivisionComboBox.defaultProps = {
  invalid: false,
  invalidText: '',
  selectedItem: null,
  disabled: true,
};
